export default "__VITE_ASSET__BZ_sMPWa__"